import request from '@/utils/request'

// 查询技术汇集分类列表
export function listClass(query) {
    return request({
        url: '/info/skilClass/list',
        method: 'get',
        params: query
    })
}

export function listClassTree(query) {
    return request({
        url: '/info/skilClass/classTree',
        method: 'get',
        params: query
    })
}

// 查询技术汇集分类详细
export function getClass(id) {
    return request({
        url: '/info/skilClass/' + id,
        method: 'get'
    })
}

// 新增技术汇集分类
export function addClass(data) {
    return request({
        url: '/info/skilClass',
        method: 'post',
        data: data
    })
}

// 修改技术汇集分类
export function updateClass(data) {
    return request({
        url: '/info/skilClass',
        method: 'put',
        data: data
    })
}

// 删除技术汇集分类
export function delClass(id) {
    return request({
        url: '/info/skilClass/' + id,
        method: 'delete'
    })
}

// 查询技术汇集分类列表
export function listByInParentId(parentIds) {
    return request({
        url: '/info/skilClass/listByInParentId',
        method: 'get',
        params: {
            parentIds: parentIds,
            pageSize: 100
        }
    })
}

// 查询技术汇集分类列表
export function listByIds(ids) {
    return request({
        url: '/info/skilClass/listByIds',
        method: 'get',
        params: {
            ids: ids
        }
    })
}
